<template>
  <NodeViewWrapper as="span" class="relative">
    <ResourceReferencePopover :resource="resource" :label="node.attrs.label" />
  </NodeViewWrapper>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { nodeViewProps, NodeViewWrapper } from '@tiptap/vue-3'
import ResourceReferencePopover from '@/resources/ResourceReferencePopover.vue'
import { usePresentLevelsStore } from '@/presentlevels/presentlevels.store'
import { Resource } from '@/resources/resource_types'

const props = defineProps({
  ...nodeViewProps
})

const presentLevelsStore = usePresentLevelsStore()
const resource = computed<Resource | null>(() => {
  const resourceUUID = props.node.attrs.resourceUUID
  return resourceUUID ? (presentLevelsStore.resourcesByUUID[resourceUUID] as Resource) ?? null : null
})
</script>
